var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCauseWithBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5359",
    "data-name": "Group 5359",
    transform: "translate(0 -0.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(0 0.209)",
    fill: "#fff8e4",
    stroke: "#ffc629",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 77.5,
    r: 77.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 77.5,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961",
    transform: "translate(23.501 19.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974",
    transform: "translate(53.651 16.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4961-2",
    "data-name": "Group 4961",
    transform: "translate(13.491 8.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M324.712,80.114a1.226,1.226,0,0,1-1.226-1.226V64.171a1.226,1.226,0,1,1,2.453,0V78.888A1.226,1.226,0,0,1,324.712,80.114Z",
    transform: "translate(-323.486 -62.944)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M362.472,29.541a12.264,12.264,0,0,0-12.264,12.264v2.453h2.453a12.264,12.264,0,0,0,12.264-12.264V29.541Z",
    transform: "translate(-350.208 -29.541)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M364.857,29.609l.068-.068h-2.453a12.264,12.264,0,0,0-12.264,12.264v2.453l3.748-3.748A12.268,12.268,0,0,1,364.857,29.609Z",
    transform: "translate(-350.208 -29.541)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M361.177,33.288a12.268,12.268,0,0,1-10.9,10.9l-.068.068h2.453a12.264,12.264,0,0,0,12.264-12.264V29.541Z",
    transform: "translate(-350.208 -29.541)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    transform: "translate(3.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M347.207,40.031h-2.453a1.226,1.226,0,0,1-1.226-1.226V36.352a13.5,13.5,0,0,1,4.577-10.128,1.227,1.227,0,1,1,1.622,1.841,11.045,11.045,0,0,0-3.746,8.287v1.226h1.226A11.05,11.05,0,0,0,358.245,26.54V25.314h-1.226a10.959,10.959,0,0,0-4.415.918,1.227,1.227,0,0,1-.982-2.248,13.4,13.4,0,0,1,5.4-1.123h2.453a1.226,1.226,0,0,1,1.227,1.226V26.54A13.506,13.506,0,0,1,347.207,40.031Z",
    transform: "translate(-343.528 -22.861)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    d: "M324.713,43.71a1.226,1.226,0,0,1-.867-2.094l18.4-18.4a1.226,1.226,0,1,1,1.734,1.734l-18.4,18.4A1.223,1.223,0,0,1,324.713,43.71Z",
    transform: "translate(-323.486 -22.861)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4973",
    "data-name": "Group 4973",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    "data-name": "Path 3468",
    d: "M266.491,31.445a8.585,8.585,0,0,0-8.585-8.585H256.68v1.226a8.585,8.585,0,0,0,8.585,8.585h1.227Z",
    transform: "translate(-256.68 -22.86)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M257.906,22.86H256.68v.088a8.586,8.586,0,0,1,7.358,8.5v1.139a8.661,8.661,0,0,0,1.226.088h1.227V31.445A8.585,8.585,0,0,0,257.906,22.86Z",
    transform: "translate(-256.68 -22.86)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M260.359,24.086v-.87a8.58,8.58,0,0,0-2.453-.356H256.68v1.226a8.585,8.585,0,0,0,8.585,8.585h1.227v-.356A8.588,8.588,0,0,1,260.359,24.086Z",
    transform: "translate(-256.68 -22.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M261.038,28.445h-1.227A9.823,9.823,0,0,1,250,18.634V17.407a1.226,1.226,0,0,1,1.227-1.226h1.226a9.822,9.822,0,0,1,9.811,9.811v1.226A1.226,1.226,0,0,1,261.038,28.445Zm-8.585-9.811a7.366,7.366,0,0,0,7.358,7.358A7.367,7.367,0,0,0,252.453,18.634Z",
    transform: "translate(-250 -16.181)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972",
    transform: "translate(9.811 9.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M308.35,75.757a1.223,1.223,0,0,1-.867-.359L303.8,71.719a1.226,1.226,0,0,1,1.734-1.734l3.679,3.679a1.226,1.226,0,0,1-.867,2.094Z",
    transform: "translate(-303.444 -69.625)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988",
    transform: "translate(38.934 39.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(1.226 14.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M229.249,269.881a3.67,3.67,0,0,0,1-7.2c-2.907-14.039-2.224-32.041-19.394-39.4H198.588c-17.17,7.358-16.488,25.36-19.394,39.4a3.67,3.67,0,0,0,1,7.2Z",
    transform: "translate(-176.513 -223.277)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4976",
    "data-name": "Group 4976",
    transform: "translate(15.943 14.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M295.7,262.677c-2.907-14.039-2.224-32.041-19.394-39.4H271.4a23.162,23.162,0,0,1-3.445,43.744l-11.272,2.86H294.7a3.67,3.67,0,0,0,1-7.2Z",
    transform: "translate(-256.68 -223.277)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977",
    transform: "translate(1.226 14.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M185.1,269.881a3.67,3.67,0,0,1-1-7.2c2.906-14.039,2.224-32.041,19.394-39.4h-4.906c-17.17,7.358-16.488,25.36-19.394,39.4a3.67,3.67,0,0,0,1,7.2Z",
    transform: "translate(-176.513 -223.277)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4978",
    "data-name": "Group 4978",
    transform: "translate(18.396 26.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M305.608,321.594h-34.34a1.226,1.226,0,0,1,0-2.453h34.34a2.444,2.444,0,0,0,.663-4.8,1.229,1.229,0,0,1-.867-.931c-.521-2.521-.919-5.1-1.338-7.823-.989-6.419-2.011-13.059-4.753-18.712a1.226,1.226,0,1,1,2.206-1.071c2.9,5.986,3.955,12.81,4.971,19.41.379,2.455.737,4.786,1.182,7.04a4.9,4.9,0,0,1-2.065,9.338Z",
    transform: "translate(-270.042 -285.117)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4979",
    "data-name": "Group 4979",
    transform: "translate(45.112 21.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M417.569,266.338a1.225,1.225,0,0,1-1.032-.562q-.352-.549-.734-1.08a1.226,1.226,0,1,1,1.991-1.432c.28.389.547.783.806,1.184a1.227,1.227,0,0,1-1.03,1.891Z",
    transform: "translate(-415.571 -262.754)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4980",
    "data-name": "Group 4980",
    transform: "translate(0 13.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M180.871,265.654h-6.132a4.9,4.9,0,0,1-2.065-9.338c.446-2.253.8-4.583,1.182-7.038,1.9-12.308,4.045-26.259,18.8-32.581a1.213,1.213,0,0,1,.483-.1H205.4a1.214,1.214,0,0,1,.483.1,27.123,27.123,0,0,1,8.851,5.973,1.226,1.226,0,1,1-1.758,1.71,24.253,24.253,0,0,0-7.829-5.33H193.389c-13.293,5.831-15.233,18.423-17.109,30.6-.42,2.726-.817,5.3-1.338,7.821a1.229,1.229,0,0,1-.867.931,2.444,2.444,0,0,0,.664,4.8h6.132a1.226,1.226,0,1,1,0,2.453Z",
    transform: "translate(-169.833 -216.597)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981",
    transform: "translate(20.849 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M285.855,149.791a2.454,2.454,0,0,0-2.249,3.433l2.249,5.151h12.264l2.249-5.151a2.454,2.454,0,0,0-2.249-3.433Z",
    transform: "translate(-283.402 -149.791)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4982",
    "data-name": "Group 4982",
    transform: "translate(33.113 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M351.987,152.149a1.85,1.85,0,0,0-1.779-2.358h2.453a2.454,2.454,0,0,1,2.249,3.433l-2.249,5.152h-2.453Z",
    transform: "translate(-350.208 -149.791)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4983",
    "data-name": "Group 4983",
    transform: "translate(20.849 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M286.529,152.149a1.85,1.85,0,0,1,1.779-2.358h-2.453a2.454,2.454,0,0,0-2.249,3.433l2.249,5.152h2.453Z",
    transform: "translate(-283.402 -149.791)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4984",
    "data-name": "Group 4984",
    transform: "translate(19.623 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M292.665,154.149H280.4a1.224,1.224,0,0,1-1.124-.736l-2.249-5.152a3.68,3.68,0,0,1,3.373-5.15h12.264a3.68,3.68,0,0,1,3.374,5.148l-2.25,5.154A1.224,1.224,0,0,1,292.665,154.149ZM281.2,151.7h10.659l1.928-4.416a1.241,1.241,0,0,0,.1-.49,1.228,1.228,0,0,0-1.226-1.227H280.4a1.228,1.228,0,0,0-1.125,1.718Z",
    transform: "translate(-276.722 -143.111)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    transform: "translate(20.849 9.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M298.119,201.46a2.453,2.453,0,0,0,0-4.906H285.855a2.453,2.453,0,0,0,0,4.906Z",
    transform: "translate(-283.402 -196.554)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4986",
    "data-name": "Group 4986",
    transform: "translate(31.887 9.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M347.206,196.554h-3.679a2.453,2.453,0,0,1,0,4.906h3.679a2.453,2.453,0,0,0,0-4.906Z",
    transform: "translate(-343.527 -196.554)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    transform: "translate(19.623 8.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M292.665,197.233H280.4a3.679,3.679,0,1,1,0-7.358h12.264a3.679,3.679,0,1,1,0,7.358ZM280.4,192.328a1.226,1.226,0,1,0,0,2.453h12.264a1.226,1.226,0,1,0,0-2.453Z",
    transform: "translate(-276.722 -189.875)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075",
    transform: "translate(16.858 65.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4994",
    "data-name": "Group 4994",
    transform: "translate(0 29.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4989",
    "data-name": "Group 4989",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    "data-name": "Rectangle 1918",
    width: 22.075,
    height: 4.906,
    rx: 2.453,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4990",
    "data-name": "Group 4990",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M160.151,451.642a1.226,1.226,0,0,0-1.226-1.226h-2.453v4.906h2.453a1.226,1.226,0,0,0,1.226-1.227Z",
    transform: "translate(-156.472 -450.416)",
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4991",
    "data-name": "Group 4991",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    "data-name": "Rectangle 1919",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4992",
    "data-name": "Group 4992",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M59.942,450.416H57.489a1.226,1.226,0,0,0-1.226,1.226V454.1a1.226,1.226,0,0,0,1.226,1.227h2.453Z",
    transform: "translate(-56.263 -450.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4993",
    "data-name": "Group 4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M71.658,451.094H52.036a2.456,2.456,0,0,1-2.453-2.453v-2.453a2.456,2.456,0,0,1,2.453-2.453h4.906a1.226,1.226,0,0,1,0,2.453H52.036v2.453H71.658v-2.453H60.621a1.226,1.226,0,0,1,0-2.453H71.658a2.456,2.456,0,0,1,2.453,2.453v2.453A2.456,2.456,0,0,1,71.658,451.094Z",
    transform: "translate(-49.583 -443.736)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023",
    transform: "translate(9.811 14.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5001",
    "data-name": "Group 5001",
    transform: "translate(0 14.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4995",
    "data-name": "Group 4995",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M131.783,454.1a1.226,1.226,0,0,1-1.226,1.227H110.934a1.226,1.226,0,0,1-1.226-1.227v-3.679h22.075Z",
    transform: "translate(-109.708 -450.416)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4996",
    "data-name": "Group 4996",
    transform: "translate(19.622 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M213.6,454.1a1.226,1.226,0,0,1-1.227,1.227h-2.453v-4.906H213.6Z",
    transform: "translate(-209.916 -450.416)",
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4997",
    "data-name": "Group 4997",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4998",
    "data-name": "Group 4998",
    transform: "translate(13.49 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4999",
    "data-name": "Group 4999",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M110.934,455.322a1.226,1.226,0,0,1-1.226-1.227v-3.679h3.679v4.906Z",
    transform: "translate(-109.708 -450.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5000",
    "data-name": "Group 5000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M126.33,451.094H105.481a2.456,2.456,0,0,1-2.453-2.453v-3.679a1.226,1.226,0,0,1,1.226-1.227H126.33a1.226,1.226,0,1,1,0,2.453H105.481v2.453H126.33a1.226,1.226,0,1,1,0,2.453Z",
    transform: "translate(-103.028 -443.736)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5008",
    "data-name": "Group 5008",
    transform: "translate(0 9.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5002",
    "data-name": "Group 5002",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    "data-name": "Rectangle 1922",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5003",
    "data-name": "Group 5003",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    width: 3.679,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5004",
    "data-name": "Group 5004",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    "data-name": "Rectangle 1924",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5005",
    "data-name": "Group 5005",
    transform: "translate(13.49 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    width: 2.453,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5006",
    "data-name": "Group 5006",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1926",
    "data-name": "Rectangle 1926",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5007",
    "data-name": "Group 5007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M126.33,424.372H104.254a1.226,1.226,0,0,1-1.226-1.226V418.24a1.226,1.226,0,0,1,1.226-1.226H126.33a1.226,1.226,0,0,1,1.227,1.226v4.906A1.226,1.226,0,0,1,126.33,424.372Zm-20.849-2.453H125.1v-2.453H105.481Z",
    transform: "translate(-103.028 -417.014)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5015",
    "data-name": "Group 5015",
    transform: "translate(0 4.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5009",
    "data-name": "Group 5009",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5010",
    "data-name": "Group 5010",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    "data-name": "Rectangle 1928",
    width: 3.679,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5011",
    "data-name": "Group 5011",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1929",
    "data-name": "Rectangle 1929",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5012",
    "data-name": "Group 5012",
    transform: "translate(13.49 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    "data-name": "Rectangle 1931",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5014",
    "data-name": "Group 5014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M126.33,397.65H104.254a1.226,1.226,0,0,1-1.226-1.226v-4.906a1.226,1.226,0,0,1,1.226-1.226H126.33a1.226,1.226,0,0,1,1.227,1.226v4.906A1.226,1.226,0,0,1,126.33,397.65ZM105.481,395.2H125.1v-2.453H105.481Z",
    transform: "translate(-103.028 -390.292)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5022",
    "data-name": "Group 5022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5016",
    "data-name": "Group 5016",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M131.783,371.475a1.226,1.226,0,0,0-1.226-1.226H110.934a1.226,1.226,0,0,0-1.226,1.226v3.679h22.075Z",
    transform: "translate(-109.708 -370.249)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5017",
    "data-name": "Group 5017",
    transform: "translate(19.622 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M213.6,371.475a1.226,1.226,0,0,0-1.227-1.226h-2.453v4.906H213.6Z",
    transform: "translate(-209.916 -370.249)",
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5018",
    "data-name": "Group 5018",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1932",
    "data-name": "Rectangle 1932",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5019",
    "data-name": "Group 5019",
    transform: "translate(13.49 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1933",
    "data-name": "Rectangle 1933",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M110.934,370.249a1.226,1.226,0,0,0-1.226,1.226v3.679h3.679v-4.906Z",
    transform: "translate(-109.708 -370.249)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5021",
    "data-name": "Group 5021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M126.33,370.928H104.254a1.226,1.226,0,0,1-1.226-1.227v-3.679a2.456,2.456,0,0,1,2.453-2.453h4.906a1.227,1.227,0,0,1,0,2.453h-4.906v2.453H125.1v-2.453H114.066a1.227,1.227,0,1,1,0-2.453H125.1a2.456,2.456,0,0,1,2.453,2.453V369.7A1.226,1.226,0,0,1,126.33,370.928Z",
    transform: "translate(-103.028 -363.569)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074",
    transform: "translate(24.528 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    transform: "translate(0 29.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M211.95,454.1a1.226,1.226,0,0,1-1.226,1.227H191.1a1.226,1.226,0,0,1-1.226-1.227v-3.679H211.95Z",
    transform: "translate(-189.875 -450.416)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5025",
    "data-name": "Group 5025",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M293.762,454.1a1.226,1.226,0,0,1-1.226,1.227h-2.453v-4.906h3.679Z",
    transform: "translate(-290.083 -450.416)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5026",
    "data-name": "Group 5026",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1934",
    "data-name": "Rectangle 1934",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5027",
    "data-name": "Group 5027",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1935",
    "data-name": "Rectangle 1935",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5028",
    "data-name": "Group 5028",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M191.1,455.322a1.226,1.226,0,0,1-1.226-1.227v-3.679h3.679v4.906Z",
    transform: "translate(-189.875 -450.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5029",
    "data-name": "Group 5029",
    transform: "translate(11.038 4.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M245.772,472.911h-1.226a1.226,1.226,0,1,1,0-2.453h1.226a1.226,1.226,0,0,1,0,2.453Z",
    transform: "translate(-243.319 -470.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5030",
    "data-name": "Group 5030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M205.269,451.094h-4.906a1.226,1.226,0,0,1,0-2.453h4.906v-2.453H185.647v2.453h6.132a1.226,1.226,0,1,1,0,2.453h-6.132a2.456,2.456,0,0,1-2.453-2.453v-3.679a1.226,1.226,0,0,1,1.226-1.227H206.5a1.226,1.226,0,0,1,1.227,1.227v3.679A2.456,2.456,0,0,1,205.269,451.094Z",
    transform: "translate(-183.194 -443.736)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038",
    transform: "translate(0 24.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5032",
    "data-name": "Group 5032",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    "data-name": "Rectangle 1936",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5033",
    "data-name": "Group 5033",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1937",
    "data-name": "Rectangle 1937",
    width: 3.679,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5034",
    "data-name": "Group 5034",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1938",
    "data-name": "Rectangle 1938",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5035",
    "data-name": "Group 5035",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5036",
    "data-name": "Group 5036",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5037",
    "data-name": "Group 5037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M206.5,424.372H184.42a1.226,1.226,0,0,1-1.226-1.226V418.24a1.226,1.226,0,0,1,1.226-1.226H206.5a1.226,1.226,0,0,1,1.227,1.226v4.906A1.226,1.226,0,0,1,206.5,424.372Zm-20.849-2.453h19.622v-2.453H185.647Z",
    transform: "translate(-183.194 -417.014)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5045",
    "data-name": "Group 5045",
    transform: "translate(0 19.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5040",
    "data-name": "Group 5040",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 3.679,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5041",
    "data-name": "Group 5041",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5042",
    "data-name": "Group 5042",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1944",
    "data-name": "Rectangle 1944",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5043",
    "data-name": "Group 5043",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1945",
    "data-name": "Rectangle 1945",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5044",
    "data-name": "Group 5044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M206.5,397.65H184.42a1.226,1.226,0,0,1-1.226-1.226v-4.906a1.226,1.226,0,0,1,1.226-1.226H206.5a1.226,1.226,0,0,1,1.227,1.226v4.906A1.226,1.226,0,0,1,206.5,397.65ZM185.647,395.2h19.622v-2.453H185.647Z",
    transform: "translate(-183.194 -390.292)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    transform: "translate(0 14.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5046",
    "data-name": "Group 5046",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1946",
    "data-name": "Rectangle 1946",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5047",
    "data-name": "Group 5047",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1947",
    "data-name": "Rectangle 1947",
    width: 3.679,
    height: 4.906,
    fill: "#edae20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5048",
    "data-name": "Group 5048",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1949",
    "data-name": "Rectangle 1949",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1950",
    "data-name": "Rectangle 1950",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M206.5,370.928H184.42a1.226,1.226,0,0,1-1.226-1.227V364.8a1.226,1.226,0,0,1,1.226-1.227H206.5a1.226,1.226,0,0,1,1.227,1.227V369.7A1.226,1.226,0,0,1,206.5,370.928Zm-20.849-2.453h19.622v-2.453H185.647Z",
    transform: "translate(-183.194 -363.569)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5059",
    "data-name": "Group 5059",
    transform: "translate(0 9.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1951",
    "data-name": "Rectangle 1951",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    width: 3.679,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5057",
    "data-name": "Group 5057",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1955",
    "data-name": "Rectangle 1955",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5058",
    "data-name": "Group 5058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M206.5,344.206H184.42a1.226,1.226,0,0,1-1.226-1.227v-4.906a1.226,1.226,0,0,1,1.226-1.227H206.5a1.226,1.226,0,0,1,1.227,1.227v4.906A1.226,1.226,0,0,1,206.5,344.206Zm-20.849-2.453h19.622V339.3H185.647Z",
    transform: "translate(-183.194 -336.847)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5066",
    "data-name": "Group 5066",
    transform: "translate(0 4.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5060",
    "data-name": "Group 5060",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    "data-name": "Rectangle 1956",
    width: 22.075,
    height: 4.906,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5061",
    "data-name": "Group 5061",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    "data-name": "Rectangle 1957",
    width: 3.679,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5062",
    "data-name": "Group 5062",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1958",
    "data-name": "Rectangle 1958",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5063",
    "data-name": "Group 5063",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1959",
    "data-name": "Rectangle 1959",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5064",
    "data-name": "Group 5064",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1960",
    "data-name": "Rectangle 1960",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5065",
    "data-name": "Group 5065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M206.5,317.483H184.42a1.226,1.226,0,0,1-1.226-1.226v-4.906a1.226,1.226,0,0,1,1.226-1.227H206.5a1.226,1.226,0,0,1,1.227,1.227v4.906A1.226,1.226,0,0,1,206.5,317.483Zm-20.849-2.453h19.622v-2.453H185.647Z",
    transform: "translate(-183.194 -310.125)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5073",
    "data-name": "Group 5073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5067",
    "data-name": "Group 5067",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M211.95,291.309a1.226,1.226,0,0,0-1.226-1.227H191.1a1.226,1.226,0,0,0-1.226,1.227v3.679H211.95Z",
    transform: "translate(-189.875 -290.082)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5068",
    "data-name": "Group 5068",
    transform: "translate(19.623 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    "data-name": "Path 3510",
    d: "M293.762,291.309a1.226,1.226,0,0,0-1.226-1.227h-2.453v4.906h3.679Z",
    transform: "translate(-290.083 -290.082)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5069",
    "data-name": "Group 5069",
    transform: "translate(4.906 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1961",
    "data-name": "Rectangle 1961",
    width: 2.453,
    height: 4.906,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5070",
    "data-name": "Group 5070",
    transform: "translate(13.491 1.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    width: 3.679,
    height: 4.906,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5071",
    "data-name": "Group 5071",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    d: "M191.1,290.082a1.226,1.226,0,0,0-1.226,1.227v3.679h3.679v-4.906Z",
    transform: "translate(-189.875 -290.082)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5072",
    "data-name": "Group 5072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3512",
    "data-name": "Path 3512",
    d: "M206.5,290.761H184.42a1.226,1.226,0,0,1-1.226-1.226v-3.679a2.456,2.456,0,0,1,2.453-2.453h12.264a1.226,1.226,0,1,1,0,2.453H185.647v2.453h19.622v-2.453H201.59a1.226,1.226,0,1,1,0-2.453h3.679a2.456,2.456,0,0,1,2.453,2.453v3.679A1.226,1.226,0,0,1,206.5,290.761Z",
    transform: "translate(-183.194 -283.403)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5085",
    "data-name": "Group 5085",
    transform: "translate(59.783 75.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5076",
    "data-name": "Group 5076",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 12.264,
    cy: 12.264,
    r: 12.264,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5077",
    "data-name": "Group 5077",
    transform: "translate(6.132 6.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    "data-name": "Path 3513",
    d: "M316.8,387.418a12.265,12.265,0,0,0,17.17-17.17Z",
    transform: "translate(-316.804 -370.248)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5078",
    "data-name": "Group 5078",
    transform: "translate(1.226 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    "data-name": "Path 3514",
    d: "M290.083,355.791l12.264-12.264A12.264,12.264,0,0,0,290.083,355.791Z",
    transform: "translate(-290.083 -343.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5079",
    "data-name": "Group 5079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    d: "M296.894,363.828a13.5,13.5,0,0,1-11.686-20.237,1.227,1.227,0,1,1,2.125,1.226,11.025,11.025,0,1,0,5.454-4.728,1.227,1.227,0,1,1-.913-2.278,13.492,13.492,0,1,1,5.019,26.017Z",
    transform: "translate(-283.403 -336.847)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5080",
    "data-name": "Group 5080",
    transform: "translate(3.824 2.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M305.461,354.32a1.226,1.226,0,0,1-.843-2.116q.454-.431.949-.82a1.227,1.227,0,1,1,1.514,1.931c-.27.211-.528.435-.776.669A1.219,1.219,0,0,1,305.461,354.32Z",
    transform: "translate(-304.235 -351.122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5084",
    "data-name": "Group 5084",
    transform: "translate(9.198 6.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081",
    transform: "translate(3.066 11.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M351.435,434.054a1.226,1.226,0,0,1-1.227-1.227V431.6a1.226,1.226,0,1,1,2.453,0v1.226A1.226,1.226,0,0,1,351.435,434.054Z",
    transform: "translate(-350.208 -430.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082",
    transform: "translate(3.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M351.435,373.929a1.226,1.226,0,0,1-1.227-1.226v-1.226a1.226,1.226,0,1,1,2.453,0V372.7A1.226,1.226,0,0,1,351.435,373.929Z",
    transform: "translate(-350.208 -370.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5083",
    "data-name": "Group 5083",
    transform: "translate(0 1.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M337.8,389.2c-2.367,0-4.292-1.65-4.292-3.679a1.226,1.226,0,0,1,2.453,0c0,.653.86,1.227,1.84,1.227s1.84-.574,1.84-1.227-.86-1.226-1.84-1.226c-2.367,0-4.292-1.65-4.292-3.679s1.926-3.679,4.292-3.679,4.292,1.65,4.292,3.679a1.226,1.226,0,1,1-2.453,0c0-.653-.86-1.226-1.84-1.226s-1.84.574-1.84,1.226.86,1.227,1.84,1.227c2.367,0,4.292,1.65,4.292,3.679S340.166,389.2,337.8,389.2Z",
    transform: "translate(-333.507 -376.931)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5088",
    "data-name": "Group 5088",
    transform: "translate(9.5 99.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5086",
    "data-name": "Group 5086",
    transform: "translate(4.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M41.128,472.911H37.448a1.226,1.226,0,1,1,0-2.453h3.679a1.226,1.226,0,1,1,0,2.453Z",
    transform: "translate(-36.222 -470.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5087",
    "data-name": "Group 5087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M11.953,472.911H10.726a1.226,1.226,0,1,1,0-2.453h1.226a1.226,1.226,0,1,1,0,2.453Z",
    transform: "translate(-9.5 -470.458)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCauseWithBorder);
export default __webpack_public_path__ + "static/media/causeWithBorder.abe5fcc6804219fe76035c244c86037c.svg";
export { ForwardRef as ReactComponent };